<!--  -->
<template>
  <div>
    <div>
      <el-form
        label-position="right"
        label-width="100px"
        :model="formLabelAlign"
      >
        <!-- <el-form-item v-if="formLabelAlign.type==1" label="是否启用" style="margin-left: 15px;">
          <div style="position: relative; display: inline-block;margin-bottom:10px">
            <div>
              <div style="position: relative; display: inline-block;">
                <el-switch
                  v-model="formLabelAlign.enable"
                  :width="60"
                  :handle-size="30"
                  active-color="#13ce66"
                  inactive-color="rgb(191,191,191)"
                  :active-value="1"
                  :inactive-value="2"
                  @change="statusChange"
                />
                <div v-if="formLabelAlign.enable == 1&&formLabelAlign.type==1" style="color: #fff; position: absolute;pointer-events: none; top: 2px; left: 7px;">启用</div>
                <div v-if="formLabelAlign.enable == 2&&formLabelAlign.type==1" style="color: #fff; position: absolute;pointer-events: none; top: 2px; right: 7px;">关闭</div>
              </div>
              <span class="color"> 鼠标出现小手可点击切换</span>
            </div>
          </div>
        </el-form-item> -->
        <el-form-item
          label="小程序类型"
          style="margin-left: 15px;"
        >
          <el-select
            v-model="formLabelAlign.type"
            placeholder="请选择小程序类型"
            @change="chanegertype"
          >
            <el-option
              v-for="item in optionsr"
              :key="item.value"
              :label="item.label"
              :value="item.value"
            />
          </el-select>
        </el-form-item>
        <el-form-item
          v-if="formLabelAlign.type == 3 || formLabelAlign.type == 1"
          label="预览公众号"
          style="margin-left: 15px;"
        >
          <!-- <el-select v-model="app_idr" filterable placeholder="请选择预览公众号">
          <el-option
            v-for="item in tableData"
            :key="item.app_id"
            :label="item.account_name"
            :value="item.app_id"
          />
        </el-select> -->
          <el-autocomplete
            v-model="app_idrname"
            style="width: 210px;"
            :fetch-suggestions="querySearchAsync"
            placeholder="请输入内容"
            @select="handleSelect"
            @input="cjader"
          />
        </el-form-item>
        <!-- <el-form-item label="小程序名称">
        <el-select id="selectInput" ref="searchSelect" v-model="value" filterable placeholder="请选择" :filter-method="dataFilter" @visible-change="visibleChange" @focus="selectFocus" @blur="selectBlur" @change="selectChange">
          <el-option
            v-for="item in options"
            :key="item.value"
            :label="item.label"
            :value="item.value"
          />
        </el-select>
        <el-tag type="danger" style="font-size: 15px;margin-left: 10px;">小程序名称务必与APPID相对应</el-tag>
      </el-form-item> -->
        <el-form-item
          label="备注"
          style="margin-left: 15px;"
        >
          <el-input
            v-model="formLabelAlign.remark"
            style="width: 500px;"
          />
        </el-form-item>

        <div class="all_box">
          <div
            v-for="item,index in allfrom"
            :key="index"
            class="all_vierr"
          >
            <el-form-item style="text-align: right;">
              <el-button
                type="primary"
                icon="el-icon-copy-document"
                @click="copy(item)"
              >复制</el-button>
              <el-button
                v-if="allfrom.length!=1"
                icon="el-icon-delete"
                type="danger"
                @click="deltere(index)"
              >删除</el-button>
            </el-form-item>
            <el-form-item label="标题">
              <el-input
                v-model="item.title"
                class="serwew"
              />
            </el-form-item>
            <el-form-item label="APPID">
              <el-input
                v-model="item.app_id"
                class="serwew"
              />
            </el-form-item>
            <el-form-item label="页面路径">
              <el-input
                v-model="item.pagepath"
                class="serwew"
              />
            </el-form-item>
            <el-form-item
              v-if="formLabelAlign.type == 3"
              label="强关路径（自研短剧用）"
            >
              <el-input
                v-model="item.recent_reading_page"
                disabled
                class="serwew"
              />
            </el-form-item>
            <el-form-item
              label="路径以html结尾"
            >
              <el-radio-group v-model="item.check" @input="radioCheck(item)">
                <el-radio :label="true">是</el-radio>
                <el-radio :label="false">否</el-radio>
              </el-radio-group>
            </el-form-item>
            <el-form-item
              label="封面"
              style="margin-bottom: 40px;"
            >
              <div class="formimg">
                <img
                  v-if="item.source_material_id!=null"
                  :src="item.source_material_img"
                  alt=""
                  style="width: 100px;height: 100px;margin-right: 10px;"
                >
                <el-button
                  type="success"
                  icon="el-icon-picture-outline"
                  size="mini"
                  @click="chooseimg(index)"
                >选择封面</el-button>
                <span style="color:#ccc;margin-left: 10px;">小程序卡片图片建议大小为520*416</span>
              </div>
            </el-form-item>
            <!-- <el-form-item v-if="ghId" label="gh_id">
            <el-input v-model="item.gh_id" />
          </el-form-item> -->
          </div>
        </div>
        <el-form-item>
          <el-button
            type="primary"
            @click="sumbit"
          >确定</el-button>
          <el-button
            v-if="formLabelAlign.type == 3 || formLabelAlign.type == 1"
            type="primary"
            @click="previewrww"
          >预览</el-button>
        </el-form-item>
      </el-form>
      <!-- 上传图片弹窗 -->
      <el-dialog
        title="图片库"
        :visible.sync="dialogVisibletwo"
        width="50%"
        append-to-body
      >
        <chooseimg
          ref="mychild"
          @clickicon="clickicon"
        />
      </el-dialog>

    </div>
  </div>
</template>

<script>
// import chooseimg from './chooseimg.vue'
import chooseimg from '../../menumanagement/components/TencentCloudChooseimg.vue'
import { createMiniprogram, repeatMiniprogramList /* contactFollowUserslist */ } from '@/api/officialaccount.js'
import { officialAccountlist } from '@/api/sourceMaterial.js'
export default {
  components: { chooseimg },
  data() {
    return {
      formLabelAlign: {
        type: 3,
        // des_1: '',
        // title: '',
        // app_id: '',
        // gh_id: '',
        // pagepath: '',
        // source_material_id: null,
        remark: '',
        preview: false
      },
      allfrom: [
        {
          title: '',
          app_id: '',
          pagepath: '',
          source_material_id: null,
          source_material_img: '',
          recent_reading_page: 'pages/recommendinfo/recommendinfo.html?short_pay_no={short_pay_no}&chapter_index={chapter_index}&account_no={account_no}&promotion_link_id={promotion_link_id}',
          check: true
          // gh_id: ''
        }
      ],
      allfromchuan: [],
      allfromindex: null,
      app_idr: '',
      app_idrname: '',
      source_material_img: '',
      dialogVisibletwo: false,
      optionsr: [
        {
          value: 1,
          label: '企微消息小程序'
        },
        {
          value: 2,
          label: '微信客服小程序'
        },
        {
          value: 3,
          label: '微信官方小程序'
        }
      ],
      options: [],
      optionsFilter: [],
      value: '',
      link: [],
      ghId: false,
      query: {
        page: 1,
        pageSize: 1000,
        onlyMe: 1
      },
      tableData: []
    }
  },
  created() {},
  mounted() {},
  methods: {
    async listr() {
      // const data = await officialAccountlist(this.query)
      // this.tableData = data.data.list
      // // this.total = data.data.total
      // console.log('data', data)
    },
    // 搜索手机编号
    async querySearchAsync(value, cb) {
      const data = await officialAccountlist({ account_name: value, page: 1, pageSize: 100, onlyMe: 1 })
      cb(
        data.data.list.map(item => {
          return { ...item, value: item.account_name }
        })
      )
    },
    handleSelect(item) {
      this.app_idr = item.app_id
      // this.parameter.content.app_id = item.app_id
      // console.log('++++++',item);
    },
    cjader(val) {
      // eslint-disable-next-line eqeqeq
      if (val == '') {
        console.log('jin')
        this.app_idr = ''
      }
      console.log(val)
    },
    chooseimg(allfromindex) {
      this.allfromindex = allfromindex
      this.dialogVisibletwo = true
      setTimeout(() => {
        // 加定时器原因是，子组件页面未渲染处理就做子组件的请求导致失败，稍微延时一下就可解决问题
        this.$refs.mychild.parentHandleclick('1')
      }, 100)
    },
    clickicon(img, key) {
      this.dialogVisibletwo = false
      this.allfrom[this.allfromindex].source_material_id = key
      this.allfrom[this.allfromindex].source_material_img = img
    },
    async sumbit() {
      console.log('value', this.formLabelAlign)
      const booltwo = this.allfrom.every((item, index, array) => {
        return item.title !== ''
      })
      if (booltwo === false) {
        this.$message.error('请输入标题')
        return
      }
      const booltwor = this.allfrom.every((item, index, array) => {
        return item.app_id !== ''
      })
      if (booltwor === false) {
        this.$message.error('请输入APPID')
        return
      }
      const booltworr = this.allfrom.every((item, index, array) => {
        return item.pagepath !== ''
      })
      if (booltworr === false) {
        this.$message.error('请输入页面路径')
        return
      }
      const booltworrr = this.allfrom.every((item, index, array) => {
        return item.source_material_id !== null
      })
      if (booltworrr === false) {
        this.$message.error('请选择封面')
        return
      }
      this.handleConfirm()
      // eslint-disable-next-line eqeqeq
      // if (this.ghId == true) {
      //   const booltworrrr = this.allfrom.every((item, index, array) => {
      //     return item.gh_id !== '' || item.gh_id !== null
      //   })
      //   if (booltworrrr === false) {
      //     this.$message.error('请填写gh_id')
      //     return
      //   }
      // }
    },
    async handleConfirm() {
      console.log(1)
      this.allfromchuan = []
      if (this.formLabelAlign.type === 3) {
        console.log('进')
        this.allfromchuan = this.allfrom.map(item => {
          return { title: item.title, app_id: item.app_id, pagepath: item.pagepath, source_material_id: item.source_material_id, check: item.check, recent_reading_page: item.recent_reading_page /* gh_id: item.gh_id */ }
        })
      } else {
        this.allfromchuan = this.allfrom.map(item => {
          return { title: item.title, app_id: item.app_id, pagepath: item.pagepath, source_material_id: item.source_material_id, check: item.check /* gh_id: item.gh_id */ }
        })
      }
      try {
        const data = await createMiniprogram({ ...this.formLabelAlign, preview: false, mps: this.allfromchuan, official_app_id: this.app_idr })
        // eslint-disable-next-line eqeqeq
        if (data.code == 201) {
          this.link = data.data.mps
          this.$confirm(`需要补全链接 是否继续?`, '提示', {
            confirmButtonText: '是',
            cancelButtonText: '否',
            closeOnClickModal: false,
            type: 'warning'
          })
            .then(() => {
              console.log('this.link', this.link)
              for (let i = 0; i < this.link.length; i++) {
                this.allfrom[i].pagepath = this.link[i].pagepath
              }
              // this.formLabelAlign.pagepath = this.link
            })
            .catch(() => {
              // createMiniprogram({
              //   ...this.formLabelAlign,
              //   check: 'false'
              // }).then((res) => {
              //   this.$emit('updatawechat')
              // })
              // this.$message({
              //   type: 'info',
              //   message: '已取消删除'
              // })
            })
        } else {
          this.$emit('updatawechat')
          console.log('data', data)
        }
      } catch (err) {
        if (err.message === '小程序获取ghid失败，请填写后再提交') {
          console.log('data.code 202')
          // this.$message.error('请添加gh_id')
          this.ghId = true
        }
      }
    },
    dataFilter(val) {
      this.value = val
      if (val) {
        this.options = this.optionsFilter.filter(item => {
          if (item.label.includes(val) || item.label.toUpperCase().includes(val.toUpperCase())) {
            return true
          }
        })
      } else {
        this.options = this.optionsFilter
      }
    },
    selectFocus(e) {
      const value = e.target.value
      setTimeout(() => {
        const input = this.$refs.searchSelect.$children[0].$refs.input
        input.value = value
      })
    },
    selectBlur() {
      console.log('失去1', this.value)
      // this.formLabelAlign.app_id = this.value
      const index = this.options.findIndex(items => {
        // eslint-disable-next-line eqeqeq
        return items.value == this.value
      })
      // eslint-disable-next-line eqeqeq
      if (index != -1) {
        console.log(index)
        console.log('找到id')
        this.formLabelAlign.app_id = this.value
        this.formLabelAlign.des_1 = this.options[index].label
      } else {
        console.log('没找到id')
        this.formLabelAlign.des_1 = this.value
        // this.formLabelAlign.app_id = ''
      }
    },
    selectChange() {
      console.log('失去2', this.value)
      this.ghId = false
      this.formLabelAlign.gh_id = ''
      const index = this.options.findIndex(items => {
        // eslint-disable-next-line eqeqeq
        return items.value == this.value
      })
      // eslint-disable-next-line eqeqeq
      if (index != -1) {
        console.log(index)
        console.log('找到id')
        this.formLabelAlign.app_id = this.value
        this.formLabelAlign.des_1 = this.options[index].label
      } else {
        console.log('没找到id')
        // this.formLabelAlign.app_id = ''
      }
    },
    visibleChange(val) {
      if (!val) {
        const input = this.$refs.searchSelect.$children[0].$refs.input
        input.blur()
      }
    },
    async list() {
      const data = await repeatMiniprogramList({
        type: this.formLabelAlign.type
      })
      if (data.data == null) {
        this.options = []
        this.optionsFilter = []
      } else {
        this.options = data.data.map(item => {
          // item是数组中的每一个值
          return { label: item.des_1, value: item.app_id }
        })
        this.optionsFilter = data.data.map(item => {
          // item是数组中的每一个值
          return { label: item.des_1, value: item.app_id }
        })
        console.log('data', data)
      }
      console.log('data', data)
    },
    sendr() {
      this.list()
      this.listr()
    },
    chanegertype() {
      this.ghId = false
      this.formLabelAlign.gh_id = ''
      // this.value = ''
      // this.formLabelAlign.app_id = ''
      // this.formLabelAlign.des_1 = ''
      this.list()
    },

    async previewrww() {
      console.log('value', this.formLabelAlign)
      const booltwo = this.allfrom.every((item, index, array) => {
        return item.title !== ''
      })
      if (booltwo === false) {
        this.$message.error('请输入标题')
        return
      }
      const booltwor = this.allfrom.every((item, index, array) => {
        return item.app_id !== ''
      })
      if (booltwor === false) {
        this.$message.error('请输入APPID')
        return
      }
      const booltworr = this.allfrom.every((item, index, array) => {
        return item.pagepath !== ''
      })
      if (booltworr === false) {
        this.$message.error('请输入页面路径')
        return
      }
      const booltworrr = this.allfrom.every((item, index, array) => {
        return item.source_material_id !== null
      })
      if (booltworrr === false) {
        this.$message.error('请选择封面')
        return
      }
      // eslint-disable-next-line eqeqeq
      // if (this.ghId == true) {
      //   const booltworrrr = this.allfrom.every((item, index, array) => {
      //     return item.gh_id !== '' || item.gh_id !== null
      //   })
      //   if (booltworrrr === false) {
      //     this.$message.error('请填写gh_id')
      //     return
      //   }
      // }
      if (this.formLabelAlign.type === 3 || this.formLabelAlign.type === 1) {
        if (this.app_idr === '') {
          this.$message.error('请选择预览公众号')
          return
        }
      }

      this.allfromchuan = []
      this.allfromchuan = this.allfrom.map(item => {
        return { title: item.title, app_id: item.app_id, pagepath: item.pagepath, check: item.check, source_material_id: item.source_material_id /* gh_id: item.gh_id */ }
      })
      try {
        const data = await createMiniprogram({ ...this.formLabelAlign, official_app_id: this.app_idr, preview: true, mps: this.allfromchuan })
        // eslint-disable-next-line eqeqeq
        if (data.code == 201) {
          this.link = data.data.mps
          this.$confirm(`需要补全链接 是否继续?`, '提示', {
            confirmButtonText: '是',
            cancelButtonText: '否',
            closeOnClickModal: false,
            type: 'warning'
          })
            .then(() => {
              for (let i = 0; i < this.link.length; i++) {
                this.allfrom[i].pagepath = this.link[i].pagepath
              }
              // this.formLabelAlign.pagepath = this.link
              // createMiniprogram({
              //   ...this.formLabelAlign,
              //   check: 'false'
              // }).then((res) => {
              //   this.$emit('updatawechat')
              // })

              // this.$message({
              //   type: 'success',
              //   message: '删除成功!'
              // })
            })
            .catch(() => {
              // createMiniprogram({
              //   ...this.formLabelAlign,
              //   check: 'false'
              // }).then((res) => {
              //   this.$emit('updatawechat')
              // })
              // this.$message({
              //   type: 'info',
              //   message: '已取消删除'
              // })
            })
        } else {
          // this.$emit('updatawechat')
          this.$message({
            type: 'success',
            dangerouslyUseHTMLString: true,
            message: `${data.data.message.toString().replace(/,/g, '<br>')}`,
            duration: 5000
          })
          console.log('data', data)
        }
      } catch (err) {
        if (err.message === '小程序获取ghid失败，请填写后再提交') {
          console.log('data.code 202')
          // this.$message.error('请添加gh_id')
          this.ghId = true
        }
        // this.link = JSON.parse(JSON.stringify(err)).response.data.data.newPagePath
        // this.$confirm(`确定要补全链接 是否继续?`, '提示', {
        //   confirmButtonText: '是',
        //   cancelButtonText: '否',
        //   type: 'warning'
        // }).then(() => {
        //   this.formLabelAlign.pagepath = this.link
        //   // createMiniprogram({
        //   //   ...this.formLabelAlign,
        //   //   check: 'false'
        //   // }).then((res) => {
        //   //   this.$emit('updatawechat')
        //   // })

        //   // this.$message({
        //   //   type: 'success',
        //   //   message: '删除成功!'
        //   // })
        // }).catch(() => {
        //   // createMiniprogram({
        //   //   ...this.formLabelAlign,
        //   //   check: 'false'
        //   // }).then((res) => {
        //   //   this.$emit('updatawechat')
        //   // })
        //   // this.$message({
        //   //   type: 'info',
        //   //   message: '已取消删除'
        //   // })
        // })
      }
    },
    copy(item) {
      this.allfrom.push({
        title: item.title,
        app_id: item.app_id,
        pagepath: item.pagepath,
        source_material_id: item.source_material_id,
        source_material_img: item.source_material_img,
        recent_reading_page: item.recent_reading_page,
        check: item.check
        // gh_id: item.gh_id
      })
    },
    deltere(indexr) {
      this.allfrom.splice(indexr, 1)
    },
    radioCheck(val) {
      console.log(val)
      if (!val.check && val.pagepath.includes('.html')) {
        val.pagepath = val.pagepath.replace(/\.html/gi, '')
      }
    }
  }
}
</script>
<style scoped>
/* @import url(); 引入css类 */
.formimg {
  display: flex;
  align-items: center;
}
.all_box {
  max-height: 500px;
  overflow: auto;
  margin-left: 20px;
  /* overflow-y: auto; */
}
.serwew {
  width: 500px;
}
.all_vierr {
  border: 1px solid #efefef;
  width: 800px;
  margin-bottom: 20px;
  padding-top: 10px;
  padding-right: 10px;
  border-radius: 10px;
}
@media (max-width: 768px){
  .all_box,.all_vierr{
    width:100%;
  }
  .all_box{
    margin:0px;
  }
  .formimg span{
    position:absolute;
    font-size: 2vw;
    bottom: 0vw;
    right:0px;
  }
}
</style>
